'use strict';
; (function () {
    var orderableDrugsWithRxNormCodesModuleRoutes = [
        {
            "state": true,
            "name": "OrderableDrugsDrugStrengthFormwithRXNormCodesMasterTable",
            "url": "OrderableDrugsDrugStrengthFormwithRXNormCodesMasterTable",
            "RoutingNumber": 3111,
            templateUrl: "<div emr-orderable-drugs-with-rx-norm-codes-main-view></div>",
            files: [
                "AngularScripts/OrderableDrugsWithRxNormCodes/Directives/OrderableDrugswithRXNormCodesMainViewDirective.js",
                "AngularScripts/OrderableDrugsWithRxNormCodes/Services/OrderableDrugsWithRxNormsService.js"
            ]
        },

        {
            //"state": true,
            "name": "OrderableDrugsDrugStrengthFormwithRXNormCodesMasterTable",
            //"url": "OrderableDrugsDrugStrengthFormwithRXNormCodesMasterTable",
            "RoutingNumber": 3111,
            templateUrl: "<div emr-orderable-drugs-with-rx-norm-codes-main-view></div>",
            files: [
                "AngularScripts/OrderableDrugsWithRxNormCodes/Directives/OrderableDrugswithRXNormCodesMainViewDirective.js",
                "AngularScripts/OrderableDrugsWithRxNormCodes/Services/OrderableDrugsWithRxNormsService.js"
            ]
        },

    ]

    angular.module('EMR.OrderableDrugsWithRxNormCodesModule' , [])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(orderableDrugsWithRxNormCodesModuleRoutes, $stateProvider);
            }]);
})();
